/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DashboardSettingsResponseDto } from '../models/DashboardSettingsResponseDto';
import type { FanNumberingMaxNumberRequestDto } from '../models/FanNumberingMaxNumberRequestDto';
import type { MessageSort } from '../models/MessageSort';
import type { PromotionReactivatorDaysRequestDto } from '../models/PromotionReactivatorDaysRequestDto';
import type { ToggleStateRequestDto } from '../models/ToggleStateRequestDto';
import type { ToggleUserFeatureRequest } from '../models/ToggleUserFeatureRequest';
import type { UpdateCustomNotePresetForm } from '../models/UpdateCustomNotePresetForm';
import type { UpdateEmojiTaskbarForm } from '../models/UpdateEmojiTaskbarForm';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardSettingsService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateAiTranslation({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/settings/ai-translation',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static apiToggleReactivator({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/reactivator',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static apiSetPromotionReactivatorDays({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: PromotionReactivatorDaysRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/reactivator/days',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static apiToggleFanNumbering({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/fan-numbering',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static apiSetFanNumberingMaxNumber({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: FanNumberingMaxNumberRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/fan-numbering/max-number',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static apiToggleAutoFollow({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/auto-follow-expired-fans',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static setPriceForAutoFollowExpiredFans({
        creatorId,
        spending,
    }: {
        creatorId: number,
        spending: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/auto-follow-expired-fans/minimum-spending',
            query: {
                'creatorId': creatorId,
                'spending': spending,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateExtensionFeatures({
        requestBody,
    }: {
        requestBody: ToggleUserFeatureRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/extension-features',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateEmojiTaskbar({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: UpdateEmojiTaskbarForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/emoji-taskbar/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static toggleEmojiTaskbarState({
        creatorId,
        state,
    }: {
        creatorId: number,
        state: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/emoji-taskbar/toggle/{creatorId}/{state}',
            path: {
                'creatorId': creatorId,
                'state': state,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateCustomNotePreset({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: UpdateCustomNotePresetForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/custom-note-preset/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static toggleCustomNotePreset({
        creatorId,
        state,
    }: {
        creatorId: number,
        state: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/custom-note-preset/toggle/{creatorId}/{state}',
            path: {
                'creatorId': creatorId,
                'state': state,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateCountdownAudioSound({
        creatorId,
        sound,
    }: {
        creatorId: number,
        sound: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/countdown-audio/sound/{creatorId}/{sound}',
            path: {
                'creatorId': creatorId,
                'sound': sound,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateCountdownAudioVolume({
        creatorId,
        volume,
    }: {
        creatorId: number,
        volume: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/countdown-audio/audio/{creatorId}/{volume}',
            path: {
                'creatorId': creatorId,
                'volume': volume,
            },
        });
    }
    /**
     * @returns DashboardSettingsResponseDto OK
     * @throws ApiError
     */
    public static getSettings({
        creatorId,
        ppvFollowUpMessageSortBy,
    }: {
        creatorId: number,
        ppvFollowUpMessageSortBy?: MessageSort,
    }): CancelablePromise<DashboardSettingsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings',
            query: {
                'creatorId': creatorId,
                'ppvFollowUpMessageSortBy': ppvFollowUpMessageSortBy,
            },
        });
    }
    /**
     * @returns DashboardSettingsResponseDto OK
     * @throws ApiError
     */
    public static getDashboardSettings({
        creatorId,
        ppvFollowUpMessageSortBy,
    }: {
        creatorId: number,
        ppvFollowUpMessageSortBy?: MessageSort,
    }): CancelablePromise<DashboardSettingsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/settings',
            query: {
                'creatorId': creatorId,
                'ppvFollowUpMessageSortBy': ppvFollowUpMessageSortBy,
            },
        });
    }
}
